(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kraft-pack-review"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kraft-review').forEach(section=>{
 section.querySelectorAll('[data-kraft-image]').forEach(button=>button.addEventListener('click',()=>{
  const image=section.querySelector('.kraft-review__main-image');
  image.src=button.dataset.kraftImage;
  image.alt=button.dataset.kraftAlt;
 }));
});

  } catch(e) { console.error(e); }
})();
})();
